import { namespace } from '../../globals';
import type { IDevice } from '../types';
import { getCanvasFingerprint, getAudioFingerprint, getWebGLFingerprint } from '../fingerprint'
import { md5, uuid } from '@roai/shared';
import type { IStorage } from '../../adapter';

const id = `__TD_${namespace}_uuid__`;

export async function generateDeviceFingerprint(storage: IStorage | Storage) {
  let val = await storage.getItem(id);
  if (val !== null && val !== '') {
    return val;
  }
  val = uuid();
  await storage.setItem(id, val);
  return val;
}

export async function getDeviceInfo(gdpr = false, storage: IStorage | Storage): Promise<IDevice> {

  return {
    aa: gdpr ? md5(await generateDeviceFingerprint(storage)).toString() : '',
    ab: gdpr ? getCanvasFingerprint(): '',
    ac: String(navigator.hardwareConcurrency),
    ad: screen.width,
    ae: screen.height,
    af: window.innerWidth,
    ag: window.innerHeight,
    ah: window.devicePixelRatio,
    ai: gdpr ? getWebGLFingerprint() : '',
    aj: gdpr ? await getAudioFingerprint() : '',
    ak: navigator.deviceMemory ?? 0,
    al: navigator.maxTouchPoints,
    am: screen.colorDepth,
    an: screen.pixelDepth,
  }
}
